import { render, staticRenderFns } from "./wx-header.vue?vue&type=template&id=1c217767"
import script from "./wx-header.vue?vue&type=script&lang=js"
export * from "./wx-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports